import type { DataTableRowEventParams } from '@/components/custom/erp/data-table-v2';
import { ConfirmationDialog, ErpDataTableV2 } from '@/components/custom/erp';
import { NganHang, NganHangInput } from '@/types/schemas';
import { getDataTableColumns } from './cols-definition';
import { ActionBar, FormDialog } from './components';
import { useCRUD, useForms } from '@/hooks';
import { QUERY_KEYS } from '@/constants';

export default function DanhMucNganHang() {
  const {
    addItem,
    updateItem,
    deleteItem,
    refreshData,
    isLoading,
    data,
    totalItems,
    currentPage,
    handlePageChange,
    fetchDetail
  } = useCRUD<NganHang, NganHangInput>({
    endpoint: QUERY_KEYS.NGAN_HANG
  });

  const {
    showForm,
    showDelete,
    selectedObj,
    selectedRowIndex,
    formMode: mode,
    isCopyMode,
    handleCloseForm,
    handleCloseDelete,
    handleAddClick,
    handleEditClick,
    handleViewClick,
    handleDeleteClick,
    handleCopyClick,
    handleRowClick,
    clearSelection
  } = useForms<NganHang>(fetchDetail);

  const handleSubmit = async (formData: NganHangInput) => {
    try {
      if (mode === 'add') {
        await addItem(formData);
      } else if (mode === 'edit' && selectedObj) {
        await updateItem(selectedObj.uuid, formData);
      }
      handleCloseForm();
      clearSelection();
    } catch (err: unknown) {
      console.error('Error submitting form:', err);
    }
  };

  return (
    <div className='flex h-full min-h-screen w-full min-w-0 max-w-full flex-col lg:overflow-hidden'>
      {showForm && (
        <FormDialog
          mode={mode}
          open={showForm}
          onClose={handleCloseForm}
          onAddButtonClick={handleAddClick}
          onEditButtonClick={handleEditClick}
          onCopyButtonClick={handleCopyClick}
          onWatchButtonClick={handleViewClick}
          onDeleteButtonClick={handleDeleteClick}
          onSubmit={handleSubmit}
          initialData={mode === 'add' && !isCopyMode ? undefined : selectedObj}
        />
      )}

      <div className='w-full'>
        <ActionBar
          onAddIconClick={handleAddClick}
          onEditIconClick={handleEditClick}
          onDeleteIconClick={handleDeleteClick}
          onCopyIconClick={handleCopyClick}
          onWatchIconClick={handleViewClick}
          onRefreshClick={refreshData}
        />

        <ErpDataTableV2
          tables={[
            {
              name: '',
              rows: data,
              columns: getDataTableColumns()
            }
          ]}
          selectedRowId={selectedRowIndex ? String(selectedRowIndex) : undefined}
          onRowClick={params => handleRowClick(params as DataTableRowEventParams<NganHang>)}
          totalItems={totalItems}
          currentPage={currentPage}
          onPageChange={handlePageChange}
          loading={isLoading}
        />
      </div>

      {showDelete && selectedObj && (
        <ConfirmationDialog
          onClose={handleCloseDelete}
          onConfirm={() => {
            deleteItem(selectedObj.uuid);
            handleCloseDelete();
            clearSelection();
            handleCloseForm();
          }}
        />
      )}
    </div>
  );
}
